{
  "_doc": [
    "Single source of truth for the PRODUCT brand (handoff §8a). A rebrand is an edit here plus",
    "an image rebuild: the web app and mobile app import this file through @myrentalmate/brand,",
    "the API reads it at startup (app/brand.py), and web/index.html is filled from it at build time.",
    "scripts/check_brand.py fails the checks on any hard-coded product name or domain elsewhere.",
    "",
    "domains: primary first. appHost is the web app's hostname.",
    "colors: the palette is adapted from the MyCivilMate Accounting dashboard (navy + warm gold on",
    "ledger paper). Gold is for fills and accents; never use it as text on a light background.",
    "",
    "NOT here: internal identifiers (Azure resource names, npm scope, Python package names, DB",
    "names) and per-org branding (each property management company's own name and logo, stored on",
    "the org row and shown on its /o/<slug> sign-in page and resident-facing documents)."
  ],
  "name": "MyRentalMate",
  "legalEntity": "Chanz Automation LLC",
  "tagline": "Property management software",
  "domains": ["myrentalmate.com"],
  "appHost": "app.myrentalmate.com",
  "mailboxes": {
    "support": "support",
    "noreply": "noreply",
    "privacy": "privacy",
    "legal": "legal"
  },
  "titles": {
    "web": "MyRentalMate",
    "api": "MyRentalMate API",
    "mobile": "MyRentalMate",
    "description": "Property management software: leasing, resident portal, payments, maintenance and accounting."
  },
  "fonts": {
    "body": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    "mono": "'SF Mono', Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
  },
  "colors": {
    "light": {
      "primaryDark": "#152238",
      "primary": "#1e3a5f",
      "primaryLight": "#2d5278",
      "primaryPale": "#e8ecf2",
      "accentDark": "#b8935f",
      "accent": "#d4a574",
      "accentLight": "#e4c09f",
      "accentPale": "#f8f4ee",
      "background": "#f8f6f3",
      "surface": "#ffffff",
      "border": "#dcd9d0",
      "text": "#2a2a2a",
      "textMuted": "#5b6474",
      "success": "#2d5f3e",
      "error": "#8b2635",
      "warning": "#8a5a14",
      "info": "#3d5a80"
    },
    "dark": {
      "primaryDark": "#5f86b8",
      "primary": "#8fb0d9",
      "primaryLight": "#b9cfe9",
      "primaryPale": "#1c2a40",
      "accentDark": "#b8935f",
      "accent": "#d4a574",
      "accentLight": "#e4c09f",
      "accentPale": "#2a2419",
      "background": "#0f1622",
      "surface": "#172131",
      "border": "#2a3546",
      "text": "#e6e9ee",
      "textMuted": "#9aa6b8",
      "success": "#6fbf8a",
      "error": "#e07a86",
      "warning": "#e2b36f",
      "info": "#8fa9cf"
    }
  }
}
